import { render, staticRenderFns } from "./LeadSampleOders.vue?vue&type=template&id=60ddd7f4&"
import script from "./LeadSampleOders.vue?vue&type=script&lang=js&"
export * from "./LeadSampleOders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports